class AGW {
    // -------------------------------------------------------------------------
    // Detection adblocker
    // -------------------------------------------------------------------------

    static blockerCache = null;
    static blockerPending = null;

    static async hasBlocker() {
        if (AGW.blockerCache !== null) {
            return AGW.blockerCache;
        }

        if (AGW.blockerPending) {
            return AGW.blockerPending;
        }

        AGW.blockerPending = AGW.fetchAdsGoogle()
            .then((res) => {
                AGW.blockerCache = res;
                return res;
            })
            .finally(() => {
                AGW.blockerPending = null;
            });

        return AGW.blockerPending;
    }

    static async fetchAdsGoogle() {
        try {
            const controller = new AbortController();
            const signal = controller.signal;

            const timeoutId = setTimeout(() => {
                controller.abort();
            }, 15000);

            const result = await fetch(
                "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
                {
                    method: "HEAD",
                    signal,
                },
            ).finally(() => {
                clearTimeout(timeoutId);
            });

            const contentLength = result.headers.get("content-length");

            return contentLength === null || !(parseInt(contentLength) > 40000);
        } catch {
            return true;
        }
    }

    static async test() {
        const test = document.createElement("div");
        test.className = "ads";
        test.style.setProperty("position", "fixed");
        test.style.setProperty("top", 0);
        test.style.setProperty("left", 0);
        test.style.setProperty("background-color", "red");
        test.style.setProperty("width", "100px");
        test.style.setProperty("height", "100px");
        document.querySelector("body").prepend(test);
        console.log(window.getComputedStyle(test, null).display);
    }

    // -------------------------------------------------------------------------
}

window.AGW = AGW;
